import React, { Component } from 'react';
import firebase from 'firebase';
import MachineDiagramsAddView from '../views/MachineDiagramsAddView';
import { base } from '../../base';

class MachineDiagramsAddContainer extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(values, file) {
        const extraUser = this.props.extraUser;
        const machineId = this.props.machineId;

        const storageRef = firebase.storage().ref();
        const fileName = `diagrams/${file.name}`;
        const uploadTask = storageRef.child(fileName).put(file);
        // .then((snapshot) => {
        //         snapshot.ref.getDownloadURL().then((downloadURL) => {
        //             base.push(`quotations/${this.props.extraUser.companyid}/`, {
        //                 data: {
        //                     author: extraUser.key,
        //                     cost: values.cost,
        //                     details: values.details,
        //                     machineid: machineId,
        //                     file: downloadURL,
        //                     time: (new Date()).getTime(),
        //                 },
        //                 then(err) {
        //                     if (!err) {
        //                         // TODO: make something on error
        //                         // Router.transitionTo('dashboard');
        //                     }
        //                 },
        //             });
        //             // user.updateProfile({
        //             //     photoURL: downloadURL,
        //             // }).then(() => {
        //             // }).catch((error) => {
        //             //     console.log(error);
        //             // });
        //         });
        //     });
        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
            (snapshot) => {
                // Get task progress, including the number of bytes uploaded and
                // the total number of bytes to be uploaded
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log(`Upload is ${progress}% done`);
                switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                    console.log('Upload is paused');
                    break;
                case firebase.storage.TaskState.RUNNING: // or 'running'
                    console.log('Upload is running');
                    break;
                default:
                    break;
                }
            }, (error) => {
                console.log(error);
            }, () => {
                // Upload completed successfully, now we can get the download URL
                uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                    base.push(`diagrams/${this.props.extraUser.companyid}/`, {
                        data: {
                            author: extraUser.key,
                            details: values.details,
                            file: downloadURL,
                            type: values.type,
                            brand: values.brand,
                        },
                        then(err) {
                            if (!err) {
                                // TODO: make something on error
                                // Router.transitionTo('dashboard');
                            }
                        },
                    });
                });
            });
    }

    render() {
        return (
            <MachineDiagramsAddView
                handleSubmit={this.handleSubmit}
                user={this.props.user}
                extraUser={this.props.extraUser}
            />
        );
    }
}

export default MachineDiagramsAddContainer;



// WEBPACK FOOTER //
// ./src/components/containers/MachineDiagramsAddContainer.js